import React from "react";
import { BackTop } from "antd";
import "./CommunityGuidelines.css";

class CommunityGuidelines extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="constrain">
        <div className="guidelines-container">
          <div className="guidelines-header">
            <h1>COMMUNITY GUIDELINES</h1>
            <p className="last-updated">Last Updated: December 2025</p>
          </div>

          <div className="guidelines-content">
            {/* Introduction */}
            <section className="guidelines-section intro-section">
              <p>
                The Community Guidelines, ("Guidelines"), outline the limitations and standards of what is eligible or 
                expected from individuals or communities and apply to your access and use of the No Cap Vote Site or 
                Services, products, or other third-party services.
              </p>
              <p>
                We believe that to foster a friendly, positive, diverse, and safe environment, while supporting free 
                expression, civilly and constructively, and sharing accurate content or materials, online individuals who 
                access and use the Services are expected to communicate and interact with each other with respect, 
                thoughtfulness and balance, and acknowledge that you are solely responsible for your own actions, 
                including, but not limited to, the content or materials you upload, transmit, or submit on the Services.
              </p>
              <p>
                There may be moments where you passionately express or share your opinions or post comments stemming 
                from information that you may learn from news or economic updates, events, financial reports, friends, or 
                family, and we recognize that there may be positive, negative, discriminatory, or pejorative language used 
                to raise awareness, including to challenge or to criticize content.
              </p>
              <p>
                Additionally, there may be debates (political or otherwise) or performances (comedic or artistic) for 
                educational, entertainment, artistic, or similar purposes that may have combative or discriminatory content 
                that we may allow. However, we will not, and do not, tolerate any abusive, offensive, or violent behaviors 
                against any person or entity.
              </p>
              <p>
                We may evaluate any reported complaints or concerns about online content to determine if there are any 
                violations of the Terms of Service. As users of the Services, any violations of the Guidelines also violate 
                the Terms of Service and/or Privacy Policy. Subject to the Guidelines and local, state, national, or 
                international applicable laws, rules, and regulations, ("Applicable Laws"), you acknowledge, accept, and 
                agree that we do not permit, and you may not submit, transmit, upload, post, email, perform, display, or 
                otherwise make available, in any part of the Site, Services, or to any person(s) or entity(ies), any 
                content, photos, videos, illustrations, language, reports, or others materials relating to, in our view:
              </p>
            </section>

            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>Prohibited Content and Activities</h2>
              <ol>
                <li><a href="#section-1">Harm or Damage to the Site or Services</a></li>
                <li><a href="#section-2">Inappropriate Behaviors or Practices</a></li>
                <li><a href="#section-3">Invasion of Privacy Content</a></li>
                <li><a href="#section-4">Hateful, Obscene, Offensive Content, Language, or Activity</a></li>
                <li><a href="#section-5">Impersonating or Soliciting Content</a></li>
                <li><a href="#section-6">Violent Content or Threats</a></li>
                <li><a href="#section-7">Child Exploitation</a></li>
                <li><a href="#section-8">Self-Harm or Suicide-Related Content</a></li>
                <li><a href="#section-9">Sexual Content</a></li>
                <li><a href="#section-10">Bullying and Harassment</a></li>
                <li><a href="#section-11">Terrorism and Violent Extremism</a></li>
                <li><a href="#section-12">Animal Abuse</a></li>
                <li><a href="#section-13">Illegal Activity</a></li>
              </ol>
              <div className="additional-sections">
                <h3>Additional Information</h3>
                <ul>
                  <li><a href="#violations">Violations or Breach of Terms</a></li>
                  <li><a href="#enforcement">Law Enforcement & Authorities</a></li>
                  <li><a href="#appeals">Appeals Request</a></li>
                  <li><a href="#reporting">Reporting Violations</a></li>
                </ul>
              </div>
            </div>

            {/* Section 1 */}
            <section id="section-1" className="guidelines-section">
              <h2>1. Harm or Damage to the Site or Services</h2>
              <p>The following activities are strictly prohibited:</p>
              <ul>
                <li>violating the Terms, policies, rights of the Site or Services;</li>
                <li>ad fraud. Using automated tools or scripts to deceive by inflating metrics is not permitted, 
                including, but not limited to, mutual following, false subscriptions;</li>
                <li>any other harm or damage to the Site, Services, us, you, or any other third party are strictly 
                prohibited; or</li>
                <li>linking to third-party websites or apps that install viruses or unauthorized content;</li>
              </ul>
            </section>

            {/* Section 2 */}
            <section id="section-2" className="guidelines-section">
              <h2>2. Inappropriate Behaviors or Practices</h2>
              <p>The following behaviors are not permitted:</p>
              <ul>
                <li>may not be authentic. It is necessary to have permission to post, submit, or transmit content or 
                material that you may not own or provide credit to the original source;</li>
                <li>may infringe on any copyright, trademark, trade secrets, or intellectual property materials, patents, 
                proprietary rights, privacy, data protection, or moral rights of any user, entity, or other third-party 
                right;</li>
                <li>may be improper, false, misleading, inaccurate, libelous, unfair, or containing gross exaggerations, 
                or unsubstantiated claims;</li>
                <li>repetitively contacting people without their consent, for business purposes or harassment, is strictly 
                prohibited; or</li>
                <li>impersonating someone to deceive people;</li>
              </ul>
            </section>

            {/* Section 3 */}
            <section id="section-3" className="guidelines-section">
              <h2>3. Invasion of Privacy Content</h2>
              <p>You are prohibited from:</p>
              <ul>
                <li>publicly identifying or publishing confidential information of any person or organization, without 
                permission to disclose. We do not tolerate any unlawful or unauthorized act or threats that may cause harm 
                to another;</li>
                <li>invading or infringing upon any user, entity, or third-party's privacy or publicity or moral rights 
                that is unreasonably harmful or offensive to any person or community, which may give rise to any civil or 
                criminal liability under the law; or</li>
                <li>violations of unauthorized access, use, distribution, third-party rights, personally identifiable 
                information, and the like, are strictly prohibited;</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section id="section-4" className="guidelines-section">
              <h2>4. Hateful, Obscene, Offensive Content, Language, or Activity</h2>
              <p>The following types of content are strictly prohibited:</p>
              <ul>
                <li>discrimination based on race, religion, natural origin, ethnic background, age, marital status, gender, 
                sexual orientation, disability, diseases, or in any other related unlawful manner;</li>
                <li>offensive, unlawful, bigoted, defamatory, vulgar, lewd, disparaging, obscene, threatening, harassing, 
                harmful, abusive, violent, or tortious materials, comments, slurs, or acts that may cause harm, damage, or 
                death;</li>
                <li>malicious, profane, degrading, inflammatory, or abusive language or attacks, including, but not limited 
                to, epithets, slurs, expressions, text, images, or illustrations;</li>
                <li>distasteful, controversial, sexual, or objectionable content, acts, or sounds; or</li>
                <li>content or materials displaying bodily fluids, such as vomit or blood, promoting violence, gore, 
                mutilation, or death are strictly prohibited;</li>
              </ul>
            </section>

            {/* Section 5 */}
            <section id="section-5" className="guidelines-section">
              <h2>5. Impersonating or Soliciting Content</h2>
              <p>You are prohibited from engaging in:</p>
              <ul>
                <li>contains unwanted solicitation or spam material in any format, medium, or mode of delivery;</li>
                <li>offers, engages in, promotes, incentivizes, or facilitates schemes, or money or gifts to trade for 
                followers, likes, reviews, ratings, or suchlike, that may be untrue and deceiving, through messages, email, 
                or links;</li>
                <li>negatively inciting another user or entity by repeatedly posting or uploading through countless subjects 
                or threads;</li>
                <li>provokes, incites, or conveys unwanted or nonconsensual, repeated messages to another user under any 
                thread or subject;</li>
                <li>impersonates the identity of another or misleads the origination of the content or materials; or</li>
                <li>misleads others by creating varying accounts or misleading viewers into seeing something that does not 
                exist in a video content are strictly prohibited;</li>
              </ul>
            </section>

            {/* Section 6 */}
            <section id="section-6" className="guidelines-section">
              <h2>6. Violent Content or Threats</h2>
              <p>Content that may cause physical, personal, or public injury or monetary damage or loss is prohibited:</p>
              <ul>
                <li>negatively inciting, planning, or calling for action to target individuals or specific categories of 
                people to carry out aggressive acts, pranks, that may cause harm, injury, damages, or death;</li>
                <li>threatening or attempting to physically harm others, which may include doxxing (disclosure of one's 
                mailing, home, or work address, location, personal or other information), hacking, theft, swatting, or 
                weapons;</li>
                <li>negatively inciting, planning, or calling for action to target individuals or specific categories based 
                on race, religion, natural origin, ethnic background, age, marital status, gender, sexual orientation, 
                disability, or diseases;</li>
                <li>negative speech or content, such as stereotyping, disparaging, mocking, or dehumanizing others;</li>
                <li>instructions on making explosive devices or harming people;</li>
                <li>linking to websites that contain harmful content or incites violent acts; or</li>
                <li>threatening or blackmailing people to post private, or sexual, images of another, or for any other 
                purpose, are strictly prohibited;</li>
              </ul>
            </section>

            {/* Section 7 */}
            <section id="section-7" className="guidelines-section">
              <h2>7. Child Exploitation</h2>
              <div className="critical-notice">
                <p>
                  <strong>Child Exploitation is strictly prohibited and is reported to law enforcement authorities and the 
                  National Center for Missing and Exploited Children. We have a zero-tolerance policy against Child Sexual 
                  Abuse Material (CSAM).</strong>
                </p>
              </div>
              <p>
                We may allow content or materials for educational, artistic, or documentary purposes. However, you are 
                prohibited from posting, emailing, or soliciting content or materials that:
              </p>
              <ul>
                <li>may harm, endanger, exploit, injure minors;</li>
                <li>may expose the identity of minors;</li>
                <li>displays minors drinking alcohol, smoking, drug use, fighting, or self-harm;</li>
                <li>displays indecent or sexual content, or nudity, of minors, including, but not limited to, digital 
                alterations, illustrations, cartoon images, and the like;</li>
                <li>displays, incites, or provokes inappropriate and harmful circumstances, which may lead to emotional or 
                physical harm, injury, or death;</li>
                <li>may bully, harass, insult, or deceive minors;</li>
                <li>shares links to third-party websites containing any sexual content with minors; or</li>
                <li>demonstrate any sexual interactions, grooming, language, intent to humor, with the participation of 
                minors;</li>
              </ul>
            </section>

            {/* Section 8 */}
            <section id="section-8" className="guidelines-section">
              <h2>8. Self-Harm or Suicide-Related Content</h2>
              <p>Content posted, emailed, or solicited is strictly prohibited that:</p>
              <ul>
                <li>displays, engages in, incites, glorifies, or encourages minors or adults to participate in acts of 
                self-harm or harm to others, such as eating disorders, negative self-perception, drug use, suicide notes, 
                cutting, or suchlike;</li>
                <li>identifies survivors or victims of self-harm resulting in disrespectful behaviors, attacks, or death;</li>
                <li>instructs minors or adults on how to die by self-harm; or</li>
                <li>other deliberate, self-destructive behaviors that may lead to harm to yourself or others, such as drunk 
                driving, drug abuse, or consuming dangerous substances;</li>
              </ul>
              <div className="help-notice">
                <p>
                  <strong>Need Help?</strong> We may allow discussions relating to mental health, well-being, or stunts for 
                  entertainment purposes, but not to the extent that it may harm you or others around you. If you know 
                  someone who may hurt themselves or others, please contact a substance abuse or mental health hotline, 
                  local law enforcement, healthcare provider, or a trusted person who can provide guidance and support.
                </p>
              </div>
            </section>

            {/* Section 9 */}
            <section id="section-9" className="guidelines-section">
              <h2>9. Sexual Content</h2>
              <p>
                Sexual content, expressed or implied, comments, requests, images, illustrations, or messages is strictly 
                prohibited, namely:
              </p>
              <ul>
                <li>displaying sexual toys that is nonacademic;</li>
                <li>materials or content describing sex acts or erotica;</li>
                <li>nonconsensual or consensual whipping or flogging;</li>
                <li>providing, suggesting, inciting, coercing, or offering services that are sexual in nature, such as 
                prostitution, pornography, paraphilia, or sex trafficking;</li>
                <li>sexual intercourse, activity, act(s), or excessive sexual elements;</li>
                <li>engaging in prostitution, sexual massage, escort services, or suchlike;</li>
                <li>promoting, engaging in, or exhibiting sex acts, or physically touching another without consent;</li>
                <li>derogatory comments or messages about a person's sexuality;</li>
                <li>indecent, scandalous, pornographic, including, sexually explicit content, images, materials, text, 
                phrases, statements, or language;</li>
                <li>breasts, genitals, buttocks, nipples, with the exception of active breastfeeding or pre- or 
                post-mastectomy educational content;</li>
                <li>engaging in sex trafficking, grooming, or doxxing; or</li>
                <li>linking to pornography websites, or advertising, promoting sexually explicit content. We allow you to 
                provide content that is interpreted as educational or artistic.</li>
              </ul>
            </section>

            {/* Section 10 */}
            <section id="section-10" className="guidelines-section">
              <h2>10. Bullying and Harassment</h2>
              <p>Bullying and harassment upon others is strictly prohibited, such as:</p>
              <ul>
                <li>cyberbullying, brigading, or digital aggression, including, but not limited to, identity theft, 
                cyberstalking; or</li>
                <li>sexual harassment, objectification, or attacks;</li>
              </ul>
            </section>

            {/* Section 11 */}
            <section id="section-11" className="guidelines-section">
              <h2>11. Terrorism and Violent Extremism</h2>
              <p>
                Terrorism and violent extremism are strictly prohibited. You are not permitted, for any reason, to:
              </p>
              <ul>
                <li>endorse, promote, praise, celebrate, or support organized crime, radicalization, hate groups, violent 
                extremism, or terrorism that may influence others to, or cause, harm, damage, or injure another;</li>
                <li>endorse, promote, praise, celebrate, or support terrorist groups or criminals in tributes or songs;</li>
                <li>post, upload, display, submit, promote, or transmit logos or symbols of terrorist organizations, 
                criminals, or violent extremists;</li>
                <li>post, upload, display, submit, or transmit content that promotes the recruitment of terrorist 
                organizations, criminals, or violent extremists;</li>
                <li>link to terrorist organizations, criminals, or violent extremists for any purpose; or</li>
                <li>post, upload, display, submit, or transmit any content or link(s) associated with violent activities;</li>
              </ul>
            </section>

            {/* Section 12 */}
            <section id="section-12" className="guidelines-section">
              <h2>12. Animal Abuse</h2>
              <p>The following activities involving animals are prohibited:</p>
              <ul>
                <li>the buying, selling, or poaching of endangered species, live animals, or suchlike, from any location 
                between persons;</li>
                <li>content forcing animals to fight;</li>
                <li>intentional abuse, neglect, or harm inflicted upon animals;</li>
                <li>promoting or celebrating abuse, neglect, or the mistreatment of animals; or</li>
                <li>linking to websites that contain harmful content or incites violent acts upon animals;</li>
              </ul>
            </section>

            {/* Section 13 */}
            <section id="section-13" className="guidelines-section">
              <h2>13. Illegal Activity</h2>
              <p>The following illegal activities are strictly prohibited:</p>
              <ul>
                <li>engaging in human trafficking, doxxing, or selling children or organs;</li>
                <li>displaying or promoting online gambling activities, lotteries, or other illegal digital or mobile games 
                that do not comply with Applicable Laws. Unless you possess our expressed written permission, you may not 
                promote online gambling activities, lotteries, or other digital or mobile games through our Site or 
                Services;</li>
                <li>buying, selling, promoting, or advertising counterfeit currency or documents;</li>
                <li>disclosing bank records, credit cards, passwords, or other financial data;</li>
                <li>a public nuisance;</li>
                <li>theft, damage, or injury to a person or a person's property;</li>
                <li>engaging in prostitution;</li>
                <li>tricking, defrauding, impersonating or extorting anyone for any purpose;</li>
                <li>linking to illegal websites;</li>
                <li>the manufacturing, distribution, buying, or selling of any prescription, unregulated, or illegal drugs, 
                from any location between persons; or</li>
                <li>the buying or selling of alcohol, tobacco, firearms or accessories, or explosives from any location 
                between persons.</li>
              </ul>
            </section>

            <div className="section-divider">
              <h3>ENFORCEMENT AND APPEALS</h3>
            </div>

            {/* Violations Section */}
            <section id="violations" className="guidelines-section enforcement-section">
              <h2>Violations or Breach of Terms</h2>
              <p>
                If you have been found by moderators, staff, a community of users, or other third parties to have violated 
                or breached any of these Guidelines or Terms set forth herein, including, but not limited to, possible 
                legal liability, subject to the severity of the content or materials in violation or breach, we reserve the 
                right, at any time, at our sole discretion, for any reason, to:
              </p>
              <ol>
                <li>initially, investigate reports or complaints submitted to us;</li>
                <li>mute, remove, or alter content; or</li>
                <li>provide reasonable warnings via email, or chat, and/or</li>
                <li>restrict, terminate, suspend, disable, and/or delete, in whole or in part, your access and/or use of 
                the Services, your password, or Your Account, without noticing you, to protect us, the Site, Services, you, 
                or other third parties.</li>
              </ol>
            </section>

            {/* Law Enforcement Section */}
            <section id="enforcement" className="guidelines-section enforcement-section">
              <h2>Law Enforcement & Authorities</h2>
              <p>
                Subject to Applicable Laws, any violation of these Terms may be referred to law enforcement authorities or 
                regulators. Moreover, we are legally obligated to cooperate and provide information in response to legal 
                and formal requests.
              </p>
            </section>

            {/* Appeals Section */}
            <section id="appeals" className="guidelines-section enforcement-section">
              <h2>Appeals Request</h2>
              <p>
                If your account has been restricted, terminated suspended, or deleted for violating or breaching the Terms 
                of Service, you may appeal the decision by sending your appeal to{" "}
                <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>. Your appeal must be labeled "Appeals 
                Request" in the subject field of your email, must include your reason for requesting the appeal. Without 
                sufficient information and proper identifying subject descriptions, we are not responsible for appeals that 
                are not labeled or properly delivered, and we may not be able to respond to such an appeal.
              </p>
              <p>
                We reserve the right, without noticing you, at any time, to revise, amend, add, modify, improve, change, 
                supplement, restrict, discontinue, and/or suspend, in whole or in part, any access, use, availability, 
                feature, functionality, products, services, descriptions, errors, omissions, and/or support of the Site or 
                Services.
              </p>
            </section>

            {/* Reporting Section */}
            <section id="reporting" className="guidelines-section enforcement-section">
              <h2>Reporting Violations</h2>
              <p>
                If you believe that any of the Guidelines described herein have been violated, please notify us immediately 
                at <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.
              </p>
            </section>
          </div>
        </div>
        <BackTop />
      </div>
    );
  }
}

export default CommunityGuidelines;